import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './styles/globals.css'
import { initializeSessionManager } from './utils/sessionManager'
import { registerSW } from 'virtual:pwa-register'

// Initialize session management
const cleanupSessionManager = initializeSessionManager()

// Cleanup on unmount
window.addEventListener('beforeunload', () => {
  cleanupSessionManager()
})

// Register service worker using vite-plugin-pwa
const updateSW = registerSW({
  onNeedRefresh() {
    console.log('New version available!')
    window.dispatchEvent(new CustomEvent('pwa:update-available', {
      detail: { updateSW }
    }))
  },
  onOfflineReady() {
    console.log('Content cached for offline use')
    window.dispatchEvent(new CustomEvent('pwa:content-cached'))
  },
  onRegistered(registration) {
    console.log('Service Worker registered:', registration)
  },
  onRegisterError(error) {
    console.error('Service Worker registration failed:', error)
  }
})

// Initialize PWA features
document.addEventListener('DOMContentLoaded', () => {
  // Set theme color meta tag
  const themeColorMeta = document.querySelector('meta[name="theme-color"]')
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', '#1a1a1a')
  }
  
  // Handle iOS PWA status bar
  if (window.matchMedia('(display-mode: standalone)').matches) {
    document.body.classList.add('pwa-standalone')
  }
  
  // Initialize background sync if supported
  if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
    navigator.serviceWorker.ready.then(registration => {
      return registration.sync.register('background-sync')
    }).catch(error => {
      console.warn('Background sync not supported:', error)
    })
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)